import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { BrandListComponent } from './brand-list.component';
import { DialogComponent } from './dialog/dialog.component';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
    {
        path     : 'brandlist',
        component: BrandListComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        BrandListComponent,
        DialogComponent
    ],
    entryComponents: [DialogComponent],
    providers:[
        AuthGuard,
        RoleGuard
    ]
})
export class BrandListModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/brand-list/brand-list.module.ts